import { setErrorAlert, clearAlerts } from './../../../config/redux/alerts/alertsActions';
import { useState } from "react";
import { useDispatch } from "react-redux";
import { FormikValues } from "formik";
import { verifyCompany } from "../../../connectors/auth/connectors/index";
import {
  setCompanyData,
} from "../../../config/redux/register/registerActions";
import { LangEnum } from '../../common/enums/lang.enum';
import { useTranslation } from "react-i18next";

// VerifyCompany returns fixed Polish messages without error codes - translate the known ones
const verificationMessageKeys: { [message: string]: string } = {
  "Nie wybrano kraju": "auth.messages.verifyCountryNotSelected",
  "Firma jest zza granicy. Zweryfikuj przed dodaniem.": "auth.messages.verifyForeignCompany",
  "Firma nie istnieje lub nie jest płatnikiem VAT. Zweryfikuj przed dodaniem.": "auth.messages.verifyCompanyNotFound",
};

const translateVerificationMessage = (message: string, t: (key: string, options?: any) => string): string => {
  const taxServerError = message.match(/^Błąd serwera KAS\. Serwer zwrócił kod błedu: (.*)$/);
  if (taxServerError) {
    return t("auth.messages.verifyTaxServerError", { code: taxServerError[1] });
  }
  return verificationMessageKeys[message] !== undefined ? t(verificationMessageKeys[message]) : message;
};

export const useVerification = () => {
  const { t } = useTranslation("admin");
  const [loading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleVerification = async (
    values: FormikValues,
    { resetForm }: any
  ) => {
    if (values && !!values.nip) {
      setIsLoading(true);
      dispatch(clearAlerts())
      const res = await verifyCompany(values.nip, values.country);
      if (res) {
        setIsLoading(false);
      }

      resetForm();

      if (res.data) {

        dispatch(setCompanyData(res.data));
      } if (res.data.message) {
        dispatch(setErrorAlert(translateVerificationMessage(res.data.message, t)));
      }
    } else {
      dispatch(clearAlerts());

      resetForm();
      dispatch(setCompanyData({
        success: true, data: {
          alredyRegistered: false,
          multiDepartment: false,
          name: '',
          regon: '',
          requestId: "",
          residenceAddress: "",
          statusVat: '',
          taxNumber: '',
          companyAddress: {
            city: '',
            postal: '',
            street: '',
          },
          country: values.country ? values.country : LangEnum.Polish
        }
      }));
    }
  };

  return { handleVerification, loading };
};